module.exports = __webpack_public_path__ + "static/media/ctravels.a85864ab.png";